
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled, { ThemeContext } from "styled-components";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { getCertificado } from "../services/api";
import { getEnviarEmail } from "../services/api";
import {isMobile} from 'react-device-detect';
import { getApiResources,getResource,setLanguage,getLanguage } from "../utils/language";

export const Certificado = () => {
  const { id } = useParams<string>();
  const [certificado, setCertificado] = useState<{ Certificado: string, Cor: string, Logo: string }>();
  const [urlPdf, setUrlPdf] = useState<string>("");
  const [urlPdfWhatsapp, setUrlPdfWhatsapp] = useState<string>("");
  const [urlPdfDownload, setUrlDownload] = useState<string>("");
  const [isLoadEmail, setIsLoadEmail] = useState<boolean>(false);
  const [ismensagem, setIsMensagem] = useState<boolean>(false);


  function handleOnLoad(event: any) {
    event.target.style.height =
      event.target.contentWindow.document.body.scrollHeight + 'px';
  }

  function enviarEmail(event: any) {
    event.preventDefault();
    var idioma = getLanguage() ?? "pt";
    if (id) {
      setIsLoadEmail(true);
      getEnviarEmail(id,idioma).then((res: any) => {      
        if (res.sucesso) {
          alert("E-mail enviado com sucesso!");
          //trocar por uma mensagem na tela
        }
        else {
          alert("Ocorreu um erro ao tentar enviar o e-mail.");
        }

        setIsLoadEmail(false);
      });
    }
  }


  useEffect(() => {
    getApiResources();
    var params = "";
    if (id) {
      getCertificado(id).then((res: any) => {
        setUrlPdf(process.env.REACT_APP_DOWNLOAD + "arquivos/certificadosgarantia/certificado" + res.Codigo + ".pdf");
        setUrlDownload(res.UrlDownload);
        setUrlPdfWhatsapp("https://api.whatsapp.com/send?text=Segue%20link%20para%20acessar%20seu%20Certificado%20em%20PDF:%20" + res.UrlDownload);
        setCertificado(res);
      });
    }

  }, []);


  return (
    <CERTIFICADO>
      {urlPdf !== '' &&
        <>
          <div id="mensagem-sucesso" className="certificado__info text-center" style={{ backgroundColor: certificado?.Cor ?? "#007249" }} >
           
              <p   dangerouslySetInnerHTML={{
                                                __html: getResource("LBL_TEXTO-CERTIFICADO"),
                                            }}>

              </p>
          </div>
          <div className="text-center" style={{ marginBottom: "15px" }}>
            <a href={urlPdfWhatsapp} style={{ backgroundColor: certificado?.Cor, marginRight: "15px",marginTop:"5px" }}
              rel="Compartilhar Certificado" target="_blank"
              className="btn btn-landing">Whatsapp</a>
            <a href={urlPdfDownload} style={{ backgroundColor: certificado?.Cor, marginRight: "15px",marginTop:"5px" }}
              rel="Download Certificado" target="_blank"
              className="btn btn-landing">Download</a>           
            <a href="#" style={{ backgroundColor: certificado?.Cor, marginRight: "15px",marginTop:"5px" }}
              rel="Enviar E-mail" onClick={enviarEmail}
              className="btn btn-landing">{isLoadEmail ? "Enviando E-mail" : "E-mail"}</a>
          </div>
          {!isMobile &&
          <iframe
            style={{ borderWidth: 0, width: "100%", height: "74vh" }}
            title="Certificado"
            src={urlPdf}
          ></iframe>}

        </>
      }
      {!id &&
        <div id="mensagem-sucesso" className="certificado__info text-center" style={{ backgroundColor: certificado?.Cor }} >
          <p>Erro ao acessar o Certificado</p>
        </div>
      }
      {ismensagem &&
        <div>Mensagem de Sucesso</div>
      }
    </CERTIFICADO>
  )
}
const CERTIFICADO = styled.section`
.certificado__info {
    margin-bottom: 15px;
    font-size: 22px;
    line-height: 28px;
    color: white;
    position: relative;
    justify-content: center;
    /*background: #007249;*/
    border-radius: 30px;
    max-width: 1140px;
    display: flex;
    margin: 15px auto;
  }

`;
